jQuery(document).ready(function() {

  // Temp fix for redirection when changing page of filtered result, mob version
 
  // Mobile menu next buttons

  jQuery("nav.mobile-menu-open li.menu-item-has-children").prepend("<button class='open-next'><i class='fa fa-angle-right'></i></button>");
    jQuery("nav.mobile-menu-open li.menu-item-has-children").addClass("open-next-sub");

  // Toggle mobile sub menus
  jQuery(".open-next-sub").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

  jQuery("nav.mobile-menu-open li.menu-item-has-children li > a").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

    jQuery("nav.mobile-menu-open li.menu-item-has-children li a").on("click", function() {
    jQuery(this).find(" > ul.sub-menu").slideToggle();
  });

  jQuery("#open-mobile").on("click", function() {
    jQuery("nav.mobile-menu-open").slideToggle();
  });
  
  jQuery(".minicart").click(function(e){
      e.stopPropagation();
  });

  jQuery(document).click(function(){
      jQuery(".minicart").fadeOut(200);
  });

  jQuery("a#close-minicart").click(function(){
      jQuery(".minicart").fadeOut(200);
  });

jQuery(".woof_radio_term_28").click(function(){
      jQuery(".woof_container_inner_typavmaterial").hide(200);
      jQuery(".woof_childs_list_28").show(200);
      jQuery(".woof_childs_list_28").css('display', 'block!important');
      jQuery(".woof-sack").hide(200);
      jQuery(".woof-cont").show(200);
  });

jQuery(".woof_radio_term_18").click(function(){
      jQuery(".woof_container_product_tag").show(200);
      jQuery(".woof_container_product_tag").css('display', 'block!important');
      jQuery(".woof-sack").show(200);
      jQuery(".woof-cont").hide(200);
      jQuery(".woof_childs_list_28").hide(200);

     
  });




  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("header.main").addClass("scrolled");
      jQuery(".floating-contact").addClass("scrolled");
      jQuery(".top-bar").fadeOut(500);
    }
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() < 20) {
      jQuery("header.main").removeClass("scrolled");
      jQuery(".floating-contact").removeClass("scrolled");
      jQuery(".top-bar").fadeIn(200);
    }
  });

 
});
